import Generator from 'ettg';
import rules from 'ettg/rules.txt'; // string

export default UIScript;

function $(query, node) {
	return (node || document).querySelector(query);
}
function $$array(query, node) {
	return Array.prototype.slice.call((node || document).querySelectorAll(query));
}
function empty(node) {
	while (node.firstChild) {
		node.removeChild(node.firstChild);
	}
}

class UIScript {
	constructor() {
		this.generator = new Generator({
			loadRules: () => rules,
		});
		this.listeners = [];
	}
	// call after DOM loaded
	run() {
		this.enableNext();
		document.getElementById('nextbutton').addEventListener("click", function (evt) { evt.preventDefault(); });
		this.nextClicked();
	}
	enableNext() {
		var self = this;
		var nextMouseListener = this.nextClicked.bind(this);
		var nextKeyListener = function (evt) {
			if (evt.keyCode === 13 /*ENTER*/) {
				self.nextClicked.apply(self, arguments);
			}
		};
		document.getElementById('nextbutton').addEventListener("mousedown", nextMouseListener);
		document.getElementById('nextbutton').addEventListener("keydown", nextKeyListener);
		this.listeners.push(['mousedown', nextMouseListener]);
		this.listeners.push(['keydown', nextKeyListener]);
	}
	disableNext() {
		var nextButton = document.getElementById('nextbutton');
		this.listeners.forEach(function (l) {
			nextButton.removeEventListener(l[0], l[1]);
		});
	}
	nextClicked(evt) {
		this.disableNext();
		var title = this.generator.get();
		this.showTitle(title);
		if (evt) {
			evt.preventDefault();
		}
	}
	// title: {title, sequel?, subtitle?}
	showTitle(title) {
		this.enableNext();
		document.getElementById('nextbutton').focus();

		var titlebox = document.getElementById('titlebox');
		empty(titlebox);

		var nodes = {};
		Object.keys(title).forEach(key => {
			var node = document.createElement('div');
			node.classList.add(key);
			node.textContent = title[key];
			nodes[key] = node;
		});

		titlebox.appendChild(nodes.title);
		if (title.sequel) {
			// Need sequel, title, hr, subtitle for formatting to look nice
			titlebox.appendChild(nodes.sequel);
			//					titlebox.appendChild("<hr>");
			titlebox.appendChild(nodes.subtitle);
		}
		this.updateTweetButton(title);
	}
	updateTweetButton(title) {
		var fulltitle = title.title;
		if (title.sequel) {
			fulltitle += ": " + title.sequel + " " + title.subtitle;
		}
		fulltitle = fulltitle.toUpperCase();

		// Remove existing twitter iframe
		var twitterNode = $(".twitterContainer");
		empty(twitterNode);

		// Generate new
		var link = document.createElement("a");
		link.classList.add("twitter");
		link.classList.add("twitter-share-button");
		link.textContent = "Tweet";
		link.href = "https://twitter.com/share";
		link.setAttribute("data-text", fulltitle + " |");
		twitterNode.appendChild(link);

		// Force reload
		try {
			if (typeof twttr !== 'undefined') {
				twttr.widgets.load(); //eslint-ignore-line no-undef
			}
		} catch (e) {
			console.log(e.toString());
		}
	}
}

